import { render, staticRenderFns } from "./progress-detail-modal.vue?vue&type=template&id=31a0ea0d&scoped=true&"
import script from "./progress-detail-modal.vue?vue&type=script&lang=js&"
export * from "./progress-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./progress-detail-modal.vue?vue&type=style&index=0&id=31a0ea0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0ea0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VCol,VDialog,VDivider,VIcon})
